import ApiService from "@/shared/api";
import AbortVideoRequest from "@/shared/api/File/dataSource/api/project-manager/files/i-services/models/request/AbortVideoRequest";
import AddVideoBatchItem from "@/shared/api/File/dataSource/api/project-manager/files/i-services/models/request/AddVideoBatchItem";
import AddVideoBatchRequest from "@/shared/api/File/dataSource/api/project-manager/files/i-services/models/request/AddVideoBatchRequest";
import RoomInfoRequest from "@/shared/api/File/dataSource/api/project-manager/files/i-services/models/request/RoomInfoRequest";
import SendVideoChunkRequest from "@/shared/api/File/dataSource/api/project-manager/files/i-services/models/request/SendVideoChunkRequest";
import {
  EventsType,
  InitAddVideoItem,
  InitAddVideosRequestModel,
  IVideoApiService,
  UploadVideoChunkRequestModel,
  UploadVideoChunkResponseModel,
} from "tir-pm-file-upload-manager";
import { Events, ResponseModel } from "../models";

export class VideoApiService implements IVideoApiService {
  private readonly api = new ApiService();
  /**Событие при успешной загрузке файла */
  CompleteEvent: EventsType<number> = new Events<number>();

  constructor() {
    this.api.File.FileService.OnCompleteAddFileEvent.on((res) => {
      if (res.IsSuccess && res.Value?.FileId) {
        this.CompleteEvent.trigger(res.Value.FileId);
      }
    });
  }

  /**
   * * Удалить префик у base64
   * @param base64String
   * @returns
   */
  private removeBase64Prefix = (base64String: string): string => {
    // Найдем индекс первого вхождения "base64,"

    const base64PrefixIndex = base64String.indexOf("base64,");

    // Если префикс найден, обрезаем строку после него
    if (base64PrefixIndex !== -1) {
      return base64String.slice(base64PrefixIndex + "base64,".length);
    }

    // Если префикс не найден, возвращаем строку без изменений
    return base64String;
  };

  /**
   * Инициализация добавления видеофайлов
   * @param request
   */
  async initAddVideos(
    request: InitAddVideosRequestModel
  ): Promise<InitAddVideoItem[]> {
    const resp = await this.api.File.VideoService.addVideoBatchAsync(
      new AddVideoBatchRequest({
        TaskId: request.TaskId,
        QueueTaskId: request.QueueTaskId,
        ChatId: request.ChatId,
        FolderId: request.FolderId,
        Videos: request.Files.map(
          (video) =>
            new AddVideoBatchItem({
              FileName: video.FileName,
              FileSize: video.FileSize,
              Thumbnail: this.removeBase64Prefix(video?.Thumbnail || ""),
            })
        ),
      })
    );

    return resp.Items.map((item) => ({
      FileId: item.FileId,
      VideoId: item.VideoId,
      Url: item.Url,
      Name: item.Name,
      Size: item.Size,
      ThumbnailUrl: item.ThumbnailUrl,
    }));
  }

  /**
   * Загрузка 1 чанка
   * @param request
   */
  async uploadChunk(
    request: UploadVideoChunkRequestModel
  ): Promise<UploadVideoChunkResponseModel> {
    const resp = await this.api.File.VideoService.sendVideoChunkAsync(
      new SendVideoChunkRequest({
        VideoId: request.VideoId,
        VideoChunk: request.VideoChunk,
        IsLast: request.IsLast,
        FileId: request.IsLast ? request.FileId : undefined,
        Room: request.Room
          ? new RoomInfoRequest({
              Name: request.Room.Name,
              Type: request.Room.Type as number,
            })
          : undefined,
      })
    );

    return new UploadVideoChunkResponseModel({
      VideoId: resp.VideoId,
      ChunkIsSuccess: resp.ChunkIsSuccess,
      VideoIsSuccess: resp.VideoIsSuccess,
    });
  }
  /**
   * Отмена загрузки видео
   * @param data
   */
  async abortUploadVideo(data: AbortVideoRequest): Promise<ResponseModel> {
    return new Promise<ResponseModel>(async (resolve) => {
      const result = new ResponseModel();

      const request = new AbortVideoRequest({
        VideoId: data.VideoId,
      });

      this.api.File.VideoService.abortVideoAsync(request)
        .then(() => {
          resolve(result);
        })
        .catch((e) => {
          console.error("ERROR abortUploadVideo", e);
          result.IsSuccess = false;
          result.ErrorCode = e.ErrorCode;
          result.ErrorMessage = e.ErrorMessage;
          resolve(result);
        });
    });
  }
}
